import React from 'react'
import './css/Pricing.css'
import { useNavigate } from 'react-router-dom'

export default function Pricing () {
  const navigate = useNavigate()

  return (
    <div className='maincontainer'>
      <section>
        <div class='container py-5'>
          <div class='row text-center align-items-end'>
            {/* data-aos='zoom-out-left' */}
            <div class='col-lg-4 mb-5 mb-lg-10'>
              <div class='bg-white p-5 rounded-lg shadow'>
                
                <h2 class='h1 font-weight-bold'>
                  Free
                 
                </h2>
                <div class='custom-separator my-4 mx-auto bg-primary'></div>
                <ul class='list-unstyled my-5 text-small text-left'>
                  <li class='mb-3 '>
                    {/* <i class='fa fa-times mr-2'></i> */}
                    <del>✔ URL Detection</del>
                  </li>
                </ul>
                <a
                  href=''
                  class='btn btn-primary btn-block p-1 shadow rounded-pill'
                  onClick={() => {
                    navigate('/order')
                  }}
                  style={{ fontWeight: '20px' }}
                >
                  Subscribe
                </a>
              </div>
            </div>
            {/* //data-aos='zoom-out-right' */}
            <div class='col-lg-4 mb-3 mb-lg0'>
              <div class='bg-white p-5 rounded-lg shadow'>
              <h3 style={{padding: '10px'}}>Silver</h3>
                <h2 class='h1 font-weight-bold'>
                  रु399
                  <span class='text-small font-weight-normal ml-2'>
                    / month
                  </span>
                </h2>
                <div class='custom-separator my-4 mx-auto bg-primary'></div>
                <ul class='list-unstyled my-5 text-small text-left font-weight-normal'>
                  <li class='mb-3'>✔ 2 month full time access</li>
                  <li class='mb-3 '>
                    <del>✔ Folder & File Cleansing</del>
                  </li>
                  <li class='mb-3 '>
                    <del>✔ Real Time Protection</del>
                  </li>
                  <li class='mb-3 '>
                    <del>✔ Junk Cleaner & Ram Booster</del>
                  </li>
                  <li class='mb-3 '>
                    <del>✔ Quick, Deep and Complete Scan</del>
                  </li>
                </ul>

                <a
                  href=''
                  class='btn btn-primary btn-block p-1 shadow rounded-pill'
                  onClick={() => {
                    navigate('/order')
                  }}
                >
                  Subscribe
                </a>
              </div>
            </div>
            {/* data-aos='zoom-out-down' */}
            <div class='col-lg-4'>
              <div class='bg-white p-5 rounded-lg shadow'>
              <h3 style={{padding: '10px'}}>Gold</h3>
                <h2 class='h1 font-weight-bold'>
                  रु899
                  <span class='text-small font-weight-normal ml-2'>
                    / month
                  </span>
                </h2>
                <div class='custom-separator my-4 mx-auto bg-primary'></div>
                <ul class='list-unstyled my-5 text-small text-left font-weight-normal'>
                  <li class='mb-3'>✔ 6 month full time access</li>
                  <li class='mb-3'>✔ Folder & File Cleansing</li>
                  <li class='mb-3'>✔ Real Time Protection</li>
                  <li class='mb-3'>✔ Junk Cleaner & Ram Booster</li>
                  <li class='mb-3'>✔ Quick, Deep and Complete Scan</li>
                  <li class='mb-3'>✔ Ram Health Management</li>
                  <li class='mb-3'>✔ System Activity monitor</li>
                </ul>

                <a
                  href=''
                  class='btn btn-primary btn-block p-1 shadow rounded-pill'
                  onClick={() => {
                    navigate('/order')
                  }}
                >
                  Subscribe
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* <Order text={text}/> */}
    </div>
  )
}
